export default class DsrTemplatePickerConstants {
  static globalTemplateBannerLocalStorageKey = 'GA_SHOW_DSR_GLOBAL_TEMPLATE_BANNER';
  static globalTemplateDevId = 'XDHF0ObiR5uQbzhUDSRBd';
  static globalTemplateProdId = 'W5rWLLqYBwgBRM4g8I8KT';
  static globalTemplateId =
    process.env.NODE_ENV === 'development' || window.location.href.includes('ga-staging')
      ? DsrTemplatePickerConstants.globalTemplateDevId
      : DsrTemplatePickerConstants.globalTemplateProdId;
}
